module.exports = __webpack_public_path__ + "img/pc_02.7ab2059d.png";